<div class="modal-header">
  <h4 class="modal-title">{{ 'CAMPAIGN.EDIT_STATUS' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <form [formGroup]="statusForm" (ngSubmit)="saveChanges()">
    <div class="mb-3">
      <label for="status" class="form-label">{{ 'CAMPAIGN.SELECT_STATUS' | translate }}</label>
      <select id="status" class="form-control" formControlName="status">
        <option *ngFor="let s of availableStatuses" [value]="s.value">{{ s.label }}</option>
      </select>
    </div>
    <div class="text-end">
      <button type="button" class="btn btn-secondary me-2" (click)="activeModal.dismiss('cancel')">
        {{ 'CAMPAIGN.CANCEL' | translate }}
      </button>
      <button 
        type="submit" 
        class="btn btn-primary" 
        [disabled]="statusForm.invalid || isLoading">
        <ng-container *ngIf="isLoading; else notLoading">
          <span class="spinner-border spinner-border-sm align-middle me-2"></span>
          {{ 'WORKSPACES.CREATING' | translate }}
        </ng-container>
        <ng-template #notLoading>
          {{ 'CAMPAIGN.SAVE' | translate }}
        </ng-template>
      </button>
    </div>
  </form>
</div>
